/**
 * BankTab — extracted from EmployeeCreate.js.
 * Receives state + handlers via `ctx` prop bag.
 */
import React from 'react';
import { Input } from '../../../../components/ui/input';
import { Label } from '../../../../components/ui/label';
import { Card, CardContent, CardHeader, CardTitle } from '../../../../components/ui/card';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../../../components/ui/select';
import { Button } from '../../../../components/ui/button';
import { Checkbox } from '../../../../components/ui/checkbox';
import { Textarea } from '../../../../components/ui/textarea';
import { TabsContent } from '../../../../components/ui/tabs';
import { Badge } from '../../../../components/ui/badge';
import { Plus, Trash2, User, Building2, Briefcase, Mail, Phone, Home, CreditCard, FileText, GraduationCap, Clock, DollarSign, Users, Heart, Calendar, Wallet, RefreshCw } from 'lucide-react';

const BankTab = ({ ctx }) => {
  const {
    formData,
    handleBankChange,
  } = ctx;

  return (
          <TabsContent value="bank">
            <Card>
              <CardHeader>
                <CardTitle className="flex items-center gap-2">
                  <CreditCard className="w-5 h-5 text-stone-700" />
                  Bank Details (Infotype 0009)
                </CardTitle>
              </CardHeader>
              <CardContent>
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <Label>Bank Name</Label>
                    <Input
                      value={formData.bank_details[0]?.bank_name}
                      onChange={(e) => handleBankChange(0, 'bank_name', e.target.value)}
                      placeholder="State Bank of India"
                    />
                  </div>
                  <div>
                    <Label>Branch</Label>
                    <Input
                      value={formData.bank_details[0]?.bank_branch}
                      onChange={(e) => handleBankChange(0, 'bank_branch', e.target.value)}
                      placeholder="Main Branch"
                    />
                  </div>
                  <div>
                    <Label>Account Number</Label>
                    <Input
                      value={formData.bank_details[0]?.account_number}
                      onChange={(e) => handleBankChange(0, 'account_number', e.target.value)}
                      placeholder="XXXXXXXXXXXX"
                    />
                  </div>
                  <div>
                    <Label>Account Holder Name</Label>
                    <Input
                      value={formData.bank_details[0]?.account_holder_name}
                      onChange={(e) => handleBankChange(0, 'account_holder_name', e.target.value)}
                      placeholder="John Doe"
                    />
                  </div>
                  <div>
                    <Label>IFSC Code</Label>
                    <Input
                      value={formData.bank_details[0]?.ifsc_code}
                      onChange={(e) => handleBankChange(0, 'ifsc_code', e.target.value.toUpperCase())}
                      placeholder="SBIN0001234"
                    />
                  </div>
                  <div>
                    <Label>SWIFT Code</Label>
                    <Input
                      value={formData.bank_details[0]?.swift_code}
                      onChange={(e) => handleBankChange(0, 'swift_code', e.target.value.toUpperCase())}
                      placeholder="SBININBB"
                    />
                  </div>
                  <div>
                    <Label>Account Type</Label>
                    <select
                      value={formData.bank_details[0]?.account_type}
                      onChange={(e) => handleBankChange(0, 'account_type', e.target.value)}
                      className="w-full h-10 px-3 border rounded-md"
                    >
                      <option value="Savings">Savings</option>
                      <option value="Current">Current</option>
                      <option value="Salary">Salary</option>
                    </select>
                  </div>
                </div>
              </CardContent>
            </Card>
          </TabsContent>
  );
};

export default BankTab;
